import { useContext, useEffect } from 'react';
import { Inbox } from '@novu/react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { notificationsLocalization } from './notificationsLocalization';
import { UserContext } from 'components/contexts/UserProvider';
import { CheckCircle, IcoBell, IcoDots, Trash } from 'icone';
import { NovuNotificationContext } from 'components/contexts/NovuProvider';
import { useUnreadCount } from '@novu/notification-center';
import NovuIconAllNotifications from 'icone/ico-novu-all_notifications.svg';
import NovuIconUnreadNotifications from 'icone/ico-novu-unread_notifications.svg';
import { Button } from 'react-bootstrap';

export function NotificationCenter() {
	const navigate = useNavigate();
	const novuInfo = useContext(NovuNotificationContext);

	const { data } = useUnreadCount();

	const { myUser } = useContext(UserContext);

	const email = myUser?.email;

	useEffect(() => {
		const observer = new MutationObserver(() => {
			if (data?.count === undefined) return;
			const allNotificationsLabel = document.querySelector('span[data-localization="inbox.filters.dropdownOptions.default"]');
			const unreadLabel = document.querySelector('span[data-localization="inbox.filters.dropdownOptions.unread"]');

			const notificationList = document.querySelector('.nv-notificationList');

			const unreadNumber = document.querySelector('span[id="unread.number"]');
			if (unreadLabel && !unreadNumber && notificationList) {
				// Adding number of unread notifications
				const newUnreadNumber = document.createElement('span');
				newUnreadNumber.innerHTML = `<span className="nv-dropdownItemLabel nv-inboxStatus__dropdownItemLabel" id="unread.number">${data.count}</span>`;
				newUnreadNumber.style.position = 'absolute';
				newUnreadNumber.style.right = '20px';
				unreadLabel.after(newUnreadNumber);

				// Adding number of all notifications
				const newNotificationsNumber = document.createElement('span');
				newNotificationsNumber.innerHTML = `<span className="nv-dropdownItemLabel nv-inboxStatus__dropdownItemLabel" id="unread.number">${notificationList.children.length}</span>`;
				newNotificationsNumber.style.position = 'absolute';
				newNotificationsNumber.style.right = '20px';
				allNotificationsLabel.after(newNotificationsNumber);

				// Changing all notifications icon
				const allNotificationsIcon = allNotificationsLabel?.previousElementSibling;
				allNotificationsIcon.innerHTML = `<img src="${NovuIconAllNotifications}" style="margin: auto;height: 100%;" />`;

				// Changing unread notifications icon
				const unreadNotificationsIcon = unreadLabel?.previousElementSibling;
				unreadNotificationsIcon.innerHTML = `<img src="${NovuIconUnreadNotifications}" style="margin: auto;height: 100%;" />`;
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => observer.disconnect();
	}, [novuInfo, data]);

	if (!novuInfo || !email) {
		return (
			<Button
				className="btn btn-outline-header"
				variant="outline-header"
				disabled
				style={{
					width: '60px',
					height: '60px',
					marginLeft: '0.5rem',
				}}
			>
				<IcoBell />
			</Button>
		);
	}

	return (
		<div style={{ marginLeft: '0.5rem', width: '60px', height: '60px' }}>
			<Inbox
				socketUrl={novuInfo.socketUrl}
				backendUrl={novuInfo.restApi}
				applicationIdentifier={novuInfo.applicationId}
				subscriber={{ subscriberId: novuInfo.subscriberId, email }}
				subscriberHash={novuInfo.subscriberHash}
				preferencesFilter={{
					tags: [novuInfo.application],
				}}
				routerPush={(path) => navigate(path)}
				localization={notificationsLocalization}
				appearance={{
					elements: {
						popoverTrigger: 'btn btn-outline-header',
					},
					icons: {
						// unread: ({ class: className }) => {
						// 	return (
						// 		<div className={className}>
						// 			<IcoNovuUnreadNotifications />
						// 		</div>
						// 	);
						// },
						dots: ({ class: className }) => {
							return (
								<div className={className}>
									<IcoDots />
								</div>
							);
						},
						bell: ({ class: className }) => {
							return (
								<div className={className}>
									<IcoBell />
								</div>
							);
						},
						markAsRead: ({ class: className }) => {
							return (
								<div className={className}>
									<CheckCircle className="novu-icon-check-circle" />
								</div>
							);
						},
						markAsArchivedRead: ({ class: className }) => {
							return (
								<div className={className}>
									<Trash className="novu-icon-trash" />
								</div>
							);
						},
						markAsArchived: ({ class: className }) => {
							return (
								<div className={className}>
									<Trash className="novu-icon-trash" />
								</div>
							);
						},
						markAsUnread: ({ class: className }) => {
							return (
								<div className={className}>
									<CheckCircle className="novu-icon-check-circle" />
								</div>
							);
						},
					},
				}}
			/>
		</div>
	);
}
